import React, { useState } from 'react';

import Topcategories from '../components/Topcategories';
import Recentitems from '../components/Recentitems';
import AppLinker from '../components/display/applinker';
import CategoriesBar from '../components/link/CategoriesBar';

import AppLinks from '../components/display/AppLinks';
import NewItemsBar from '../components/NewItemsBar';

import HomeBanner from '../components/HomeBanner';
import SEO from '../components/seo/SEO';

function Home() {






  return (
    <div className="container-fluid p-0">
      <SEO
        title="ToyTrade.pk - Trade, Buy & Sell Pre-loved Toys in Pakistan"
        description="The easiest way for parents and teenagers in Pakistan to exchange pre-loved toys. Find LEGO, action figures, board games, and more on ToyTrade.pk."
        canonical="https://toytrade.pk"
      />
      <HomeBanner />



      <div className="header-choice   p-4 rounded-3 text-center">
        <h2 className="choice-headline fs-2 fw-semibold mb-4">Why choose ToyTrade?</h2>
        <div className="row g-3 g-md-4 justify-content-center">
          {[
            { id: 1, title: 'Identity Verified', desc: 'Profile ratings and reviews help verify trusted sellers' },
            { id: 2, title: 'Easy & Fast', desc: 'List your items in seconds and get offers instantly.' },
            { id: 3, title: 'Sustainable', desc: 'Give pre-loved toys a new home and reduce waste.' },
            { id: 4, title: 'Community', desc: 'Connect with other parents and build your network.' }
          ].map((item) => (
            <div className="col-6 col-md-3" key={item.id}>
              <div className="choice-card  position-relative  bg-white border-0 shadow-sm h-100 p-2 p-md-3 m-0">
                <div className="choice-card-image ratio ratio-4x3 mb-3">
                  <img src={`/images/choice_${item.id}.png`} className="img-fluid object-fit-contain p-2" alt={item.title} onError={(e) => { e.target.style.display = 'none' }} />
                </div>
                <span className="choice-number position-absolute opacity-25 fw-bold italic">{item.id}</span>
                <div className="choice-text text-center border-bottom-primary">

                  <h3 className="fs-5 fw-semibold position-relative z-1">{item.title}</h3>
                  <p className="small text-muted position-relative z-1 mb-4">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="categories-overflow-wrapper px-4 mt-4 mb-4 position-relative" style={{ zIndex: 10 }}>
        <CategoriesBar />
      </div>

      <NewItemsBar />

      <div className="header-choice halfyellow  p-4 rounded-3 position-relative overflow-hidden">
        <h2 className="choice-headline fs-2 fw-semibold mb-4 text-center">How it Works?</h2>
        <div className="row g-3">
          {[
            { id: 1, title: 'Browse Toys', desc: 'View all available toys on the website or inside ToyTrade App' },
            { id: 2, title: 'Download The App', desc: 'To buy, negotiate or swap, you must use the App' },
            { id: 3, title: 'SignUp & Login', desc: 'Connect via Google and start uploading your items' },
            { id: 4, title: 'Negotiate', desc: 'Chat and add items to the chat window for negotiation' },
            { id: 5, title: 'Trade Offers', desc: 'Chat also supports trade offers, item for item or money for item.' },
            { id: 6, title: 'Complete transaction', desc: 'Upon accepting a trade, you can communicate offline for delivery and payment' },
          ].map((item) => (
            <div className="col-12 col-md-4" key={item.id}>
              <div className="choice-card bg-white border rounded-3 p-3 shadow-sm d-flex align-items-center" style={{ height: '140px' }}>
                <div className="flex-shrink-0 me-3">
                  <img style={{ height: '100px', width: 'auto' }} src={`/images/work/work_${item.id}.png`} className="img-fluid" alt={item.title} onError={(e) => { e.target.style.display = 'none' }} />
                </div>
                <div>
                  <h4 className="fs-6 fw-bold mb-1">{item.title}</h4>
                  <p className="small text-muted mb-0 lh-sm">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="header-smart row  border-0 rounded-3 overflow-hidden bg-white shadow-sm">
        <div className="col-12 col-md-6 p-5 d-flex flex-column justify-content-center order-2 order-md-1">
          <AppLinker />
        </div>
        <div className="col-12 col-md-6 p-0 d-flex align-items-end justify-content-center order-1 order-md-2">
          <img src="/images/app_hand.png" className="img-fluid" alt="Smart" style={{ maxHeight: '500px' }} />
        </div>
      </div>



    </div>
  );
}

export default Home;
